import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

type SelectionTabBtnProps = {
  selected: boolean
}

export const SelectionTabWrapper = styled.div`
  display: flex;
  background-color: ${theme.colors.neutral.white};
  padding: ${theme.spacing.md};
  border-top-left-radius: ${theme.shapes.borderRadius.md};
  border-top-right-radius: ${theme.shapes.borderRadius.md};
  height: calc(${theme.spacing['2xl']} + ${theme.spacing.xm});
  justify-content: space-between;

  > div {
    display: flex;
    align-items: center;
    gap: ${theme.spacing.sm};
  }
`

export const SelectionTabBtn = styled.button<SelectionTabBtnProps>`
  height: 100%;
  padding: 0 ${theme.spacing.sm};
  font-family: ${theme.typography.family.primary};
  font-weight: ${theme.typography.weight.xl};
  font-size: ${theme.typography.sizes.sm};
  color: ${theme.colors.ion.state.enabled.neutral};
  background-color: transparent;

  border: none;
  box-shadow: none;

  ${({ selected }) =>
    selected &&
    css`
      color: ${theme.colors.ion.state.focus.onghost};
      border-bottom: ${theme.shapes.borderWidth.md}
        ${theme.colors.ion.state.focus.onghost};
    `}
`

export const SelectionTabCheckboxWrapper = styled.div`
  padding: 0 ${theme.spacing.sm};
`

export const SlinButtonWrapper = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
`
